import React from "react";
import { Skeleton } from "primereact/skeleton";
import { useParams } from "react-router-dom";
import { getName } from "country-list";
import ReactCountryFlag from "react-country-flag";
import { Outlet } from "react-router-dom";

import Layout from "../../Layout";
import useFileDocuments from "./actions/useFileDocuments";
import "./files_documents.scss";
import TitleBreadcrumbs from "./components/TitleBreadcrumbs";
import FileDocumentsBreadcrumbContext from "./FileDocumentsBreadcrumbContext";

function FileDocumentsLayout() {
  const { id } = useParams();
  const [selectedCategory, setSelectedCategory] = React.useState(null);
  const { states } = useFileDocuments({ id });
  return (
    <FileDocumentsBreadcrumbContext.Provider
      value={{ selectedCategory, setSelectedCategory }}
    >
      <Layout
        crumbs={[
          { label: "My Entities", url: "/entities", id: "entities" },
          {
            label: (
              <div className="flex">
                {!states?.loading ? (
                  states?.entity_detail?.name
                ) : (
                  <Skeleton width="100px" height="20px" className="mr-1" />
                )}
                {!states?.loading ? (
                  <>
                    (
                    <ReactCountryFlag
                      countryCode={states?.entity_detail?.country || ""}
                      svg
                    />{" "}
                    {getName(states?.entity_detail?.country || "")})
                  </>
                ) : (
                  <Skeleton width="150px" height="20px" className="mr-1" />
                )}
              </div>
            ),
            id: "entity",
            url: `/entity/${id}/dashboard`,
          },
          { label: "Files & Documents", id: "entity-files-document" },
        ]}
      >
        <TitleBreadcrumbs />
        <Outlet />
      </Layout>
    </FileDocumentsBreadcrumbContext.Provider>
  );
}

export default FileDocumentsLayout;
